export class Head {
    static isLoaded(): boolean {
        return Boolean(document && document.head);
    }

    static setTitle(title: string): void {
        if (Head.isLoaded()) {
            document.title = title;
        }
    }

    static setMeta(name: string, attributes: Record<string, string>): void {
        if (Head.isLoaded()) {
            const metaNode = document.querySelector(`meta[name="${name}"`);
            if (metaNode) {
                Object.entries(attributes).forEach(([key, value]) => {
                    metaNode.setAttribute(key, value);
                });
            } else {
                const meta = document.createElement('meta');
                meta.setAttribute('name', name);
                Object.entries(attributes).forEach(([key, value]) => {
                    meta.setAttribute(key, value);
                });
                document.head.appendChild(meta);
            }
        }
    }
}
